const EVENT_TRACKING_ROUTES = {
    CREATE_EVENT_HISTORY: ( CLIENT_BASIC_ID ) => `event/history/${CLIENT_BASIC_ID}`,
    GET_EVENT_HISTORY: ( CLIENT_BASIC_ID ) => `event/history/${CLIENT_BASIC_ID}`
};

export default EVENT_TRACKING_ROUTES;
